<template>
  <div class="modal-body">
    <Loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div>
        <VasionButton id="tab-settings" :classProp="calculatedClass('settings')" @vasionButtonClicked="updateSelectedTab('settings')">
          Settings
        </VasionButton>
        <VasionButton id="tab-security" :classProp="calculatedClass('security')" @vasionButtonClicked="updateSelectedTab('security')">
          Permissions
        </VasionButton>
      </div>
    <div v-show="selectedTabName === 'settings'" id="settings-tab">
      <div class="authentication-row">
        <VasionInput
          id="name"
          v-model="activeAccountConfig.name"
          name="name"
          :title="'Configuration Name'"
          placeholder="Enter Configuration Name..."
          inputType="top-white"
          width="500"
        />
        <VasionDropList
          class="separate-controls"
          v-slot="slotItem"
          v-model="selectedType"
          title="Authentication Type"
          :dataArray="authenticationTypeList"
          width="500"
          :showSearchField="false"
          type="plain-list"
          displayName="displayName"
          valueName="value"
          :isDisabled="!canChangeType"
        >
          {{ slotItem.item.displayName }}
        </VasionDropList>
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 1">
        <VasionInput
          id="username"
          v-model="activeAccountConfig.username"
          name="username"
          :title="'User Name'"
          placeholder="Enter User Name..."
          inputType="top-white"
          width="500"
        />
        <VasionInput
          class="separate-controls"
          id="password"
          v-model="activeAccountConfig.password"
          name="password"
          :title="'Password'"
          placeholder="Enter Password..."
          inputType="top-white"
          width="500"
        />
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 2">
        <VasionDropList
          v-slot="slotItem"
          v-model="selectedFieldLocation"
          title="Bearer Token Location"
          :dataArray="fieldLocationList"
          width="500"
          :showSearchField="false"
          type="plain-list"
          displayName="displayName"
          valueName="value"
        >
          {{ slotItem.item.displayName }}
        </VasionDropList>
        <VasionInput
          class="separate-controls"
          id="field"
          width="500"
          v-model="activeAccountConfig.field"
          name="field"
          title="Bearer Token Prefix"
          inputType="top-white"
          :placeholder="'Enter Bearer Token Prefix...'"
        />
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 2">
        <VasionInput
          id="Token"
          width="500"
          v-model="activeAccountConfig.token"
          name="Token"
          title="Bearer Token"
          inputType="top-white"
          :placeholder="'Enter Bearer Token...'"
        />
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 3">
        <VasionInput
          id="Client-Id"
          v-model="activeAccountConfig.clientId"
          name="Client-Id"
          :title="'Client ID'"
          placeholder="Enter Client ID..."
          inputType="top-white"
          @input="updateRedirectURI"
          @blur="clientIdOnBlur"
          width="500"
        />
        <VasionInput
          id="Client-Secret"
          class="separate-controls"
          v-model="activeAccountConfig.clientSecret"
          name="Client-Secret"
          :title="'Client Secret'"
          placeholder="Enter Client Secret..."
          inputType="top-white"
          width="500"
        />
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 3">
        <VasionInput
          id="discovery-endpoint"
          v-model="discoveryEndpoint"
          name="discovery-endpoint"
          title="OAuth Discovery Endpoint"
          inputType="top-white"
          placeholder="Enter OAuth Discovery Endpoint and click Discover OAuth..."
          width="500"
        />
        <VasionButton
          id="discover-oauth"
          class="oauth-button separate-controls"
          :classProp="'secondary'"
          @vasionButtonClicked="discoverOAuthClick"
        >
          Discover OAuth
        </VasionButton>
        <VasionButton
          id="clear-oauth"
          class="oauth-button"
          :classProp="'secondary'"
          @vasionButtonClicked="clearOAuthClick"
        >
          Clear OAuth
        </VasionButton>
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 3">
        <VasionInput
          id="oAuth-URL"
          v-model="activeAccountConfig.authUrl"
          name="oAuth-URL"
          title="oAuth URL"
          inputType="top-white"
          :isDisabled="isOAuthFromDiscovery"
          width="500"
        />
        <VasionInput
          class="separate-controls"
          id="token-URL"
          v-model="activeAccountConfig.tokenEndpoint"
          name="Token-URL"
          title="Token URL"
          inputType="top-white"
          :isDisabled="isOAuthFromDiscovery"
          width="500"
        />
      </div>
      <div class="authentication-row" v-if="activeAccountConfig.type === 3">
        <VasionInput
          v-if="!isOAuthFromDiscovery"
          id="scopes"
          v-model="activeAccountConfig.scopes"
          name="scopes"
          title="Scopes"
          inputType="top-white"
          :placeholder="'Enter comma-separated list of Scopes...'"
          width="500"
        />
        <VasionDropList
          v-if="isOAuthFromDiscovery"
          v-slot="slotItem"
          v-model="selectedScopes"
          title="Scopes"
          :dataArray="scopesList"
          :showSearchField="false"
          type="check-list"
          displayName="displayName"
          valueName="value"
          width="500"
          :openAbove="true"
        >
          {{ slotItem.item.displayName }}
        </VasionDropList>
        <VasionInput
          class="separate-controls"
          id="Client-URI"
          v-model="displayClientURI"
          name="Client-URI"
          title="Client URI"
          inputType="top-white"
          :isDisabled="true"
          :placeholder="'Enter Client ID to View Callback URI'"
          width="500"
        />
      </div>
    </div>
    <div v-show="selectedTabName === 'security'" id="security-tab">
        <div>
          <VasionListSelection
            :available-fields.sync="availableUsers"
            :selected-fields.sync="accessUsers"
            :allow-field-ordering="false"
            :available-label-text="'All Users'"
            :selected-label-text="'Access Users'"
            :unique-id="'access-users'"
          />
        </div>
        <div class="separator-div" />
        <div>
          <VasionListSelection
            :available-fields.sync="availableGroups"
            :selected-fields.sync="accessGroups"
            :allow-field-ordering="false"
            :available-label-text="'All Groups'"
            :selected-label-text="'Access Groups'"
            :unique-id="'access-groups'"
          />
        </div>
      </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'APIAuthentication',
  components: {
    Loading,
  },
  props: {
    accountConfig: {
      type: Object,
      required: true,
      default: () => {},
    },
  }, 
  data: function () {
    return {
      accessGroups: [],
      accessUsers: [],
      activeAccountConfig: {
        type: 0,
        clientId: '',
        clientSecret: '',
        name: '',
        authUrl: '',
        scheme: '',
        scopes: '',
        token: '',
        tokenEndpoint: '',
        field: '',
        fieldLocation: 0,
        accessGroups: [],
        accessUsers: [],      
      },
      authenticationTypeList: [
        { displayName: 'Basic', value: 1 },
        { displayName: 'Token', value: 2 },
        { displayName: 'OAuth', value: 3 },
      ],
      availableGroups: [],
      availableUsers: [],
      canChangeType: true,
      discoveryEndpoint: '',
      fieldLocationList: [
        { displayName: 'Header', value: 1 },
        { displayName: 'Query', value: 2 },
      ],
      fullPage: true,
      isLoading: false,
      isOAuthFromDiscovery: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      redirectURI: '',
      scopesList: [],
      selectedScopes: [],
      selectedFieldLocation: {value: 0},
      selectedTabName: 'settings',
      selectedType: {value: 0},
    }
  },
  computed: {
    displayClientURI() {
      if (this.activeAccountConfig.clientId !== "") {
        return this.activeAccountConfig.redirectURI
      }
      return ""
    },
    groupList() { return this.$store.state.security.groupList },
    oAuthURL() { return `${this.activeAccountConfig.oAuthURLBase}${this.activeAccountConfig.clientId}&redirect_uri=${this.activeAccountConfig.redirectURI}` },
  },
  watch: {
    activeAccountConfig: {
      handler: function () {
        this.$emit('updateAccountConfig', this.activeAccountConfig)
      },
      deep: true,
    },
    accessUsers: {
      handler: function (newVal) {
        this.activeAccountConfig.accessUsers = newVal.map((user) => user.value)
        this.$emit('updateAccountConfig', this.activeAccountConfig)
      },
      deep: true,
    },
    accessGroups: {
      handler: function (newVal) {
        this.activeAccountConfig.accessGroups = newVal.map((user) => user.value)
        this.$emit('updateAccountConfig', this.activeAccountConfig)
      },
      deep: true,
    },
    selectedType() {
      this.activeAccountConfig.type = this.selectedType?.value
    },
    selectedFieldLocation() {
      this.activeAccountConfig.fieldLocation = this.selectedFieldLocation?.value
    },
    selectedScopes() { 
      this.activeAccountConfig.scopes = this.selectedScopes.map((scope) => scope.value).join(',')
     },
  },
  created: async function () {
    var enabledUserList = []
      await Promise.all([
        enabledUserList = await this.$store.dispatch('security/getUserListEnabledOnly'),
        this.$store.dispatch('security/loadGroupList')
      ])
    this.redirectURI = window.location.href
    const routeName = 'integration/apiaccounts'
    const indexOf = this.redirectURI.indexOf(routeName)
    if (indexOf >= 0) {
      this.redirectURI = this.redirectURI.substring(0, indexOf + routeName.length)
    }

    if (this.accountConfig.type) {
      this.canChangeType = false
    }
    
    this.activeAccountConfig = this.accountConfig
    enabledUserList.forEach((user) => {
      const newUser = {
        name: user.Username,
        value: user.UserId,
      }
      if (this.accountConfig.accessUsers && this.accountConfig.accessUsers.includes(user.UserId)) {
        this.accessUsers.push(newUser)
      } else {
        this.availableUsers.push(newUser)
      }
    })

    this.groupList.forEach((group) => {
      const newGroup = {
        name: group.Name,
        value: group.ID,
      }

      if (this.accountConfig.accessGroups && this.accountConfig.accessGroups.includes(group.ID)) {
        this.accessGroups.push(newGroup)
      } else {
        this.availableGroups.push(newGroup)
      }
    })
    this.selectedType = this.authenticationTypeList.find((item) => item.value === this.activeAccountConfig.type)
    this.selectedFieldLocation = this.fieldLocationList.find((item) => item.value === this.activeAccountConfig.fieldLocation)
    this.updateRedirectURI()
  },
  methods: {
    calculatedClass(selectedTab) { return this.selectedTabName === selectedTab ? 'text-selected' : 'text' },
    clearOAuthClick() {
      this.activeAccountConfig.authUrl = ''
      this.activeAccountConfig.tokenEndpoint = ''
      this.activeAccountConfig.scopes = ''
      this.selectedScopes = []
      this.discoveryEndpoint = ''
      this.isOAuthFromDiscovery = false
    },
    clientIdOnBlur() {
      this.updateRedirectURI()
    },
    async discoverOAuthClick() {
      const response = await this.$store.dispatch('admin/getOAuthDiscoveryInfo', this.discoveryEndpoint)
      this.isOAuthFromDiscovery = true
      this.activeAccountConfig.authUrl = response.authorization_endpoint
      this.activeAccountConfig.tokenEndpoint = response.token_endpoint
      this.activeAccountConfig.scopes = ''
      this.scopesList = response.scopes_supported.map((scope) => {
        return {
          displayName: scope,
          value: scope,
        }
      })
      this.selectedScopes = []
    },
    updateSelectedTab(newSelectedTab) { this.selectedTabName = newSelectedTab },
    updateRedirectURI() {
      let tempclientId = this.activeAccountConfig.clientId?.replace(/\./g, '_')
      this.activeAccountConfig.redirectURI = `${this.redirectURI}/${tempclientId}`
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  @import '@/assets/css/light-theme-system-palette.scss';

  .modal-body {
    width: 1040px;
    height: 450px;
    padding-top: 16px;
  }

  .authentication-row {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }

  .oauth-button {
    margin-top: 20px;
  }

  .separate-controls {
    margin-left: 10px;
  }
</style>
